import React, { Fragment, Component } from "react";
import TaxTaskSubHeader from './TaxTaskSubHeader';
import TaxTaskToBeLinkedPageActions from "./TaxTaskToBeLinkedPageActions";
import TaxIntegrationDashboard from "./TaxIntegrationDashboard";


class TaxTaskToBeLinkedIndex extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <Fragment >
                <TaxIntegrationDashboard/>
                <TaxTaskSubHeader  />
                <TaxTaskToBeLinkedPageActions />
            </Fragment>
        );
    }
}

export default TaxTaskToBeLinkedIndex;